angular.module("digitalLeasing.module").component("providersGoodsManagement", {
    templateUrl: "ng/components/digitalLeasing/goodManagement/providersGoodsManagement/providersGoodsManagement.view.html",
    bindings: {
        model: "=", //elementToAdd
        preventivo: "=",
        provGoodIsOk: "&",
        provGoodIsNotOk: "&",
        totalAmount: "&",
        viewIndex: "=",
        newCespiteAmount: "&",
        changeStatus: "&",
        flagAllestimento: "&",
        allestimentoObj: "&",
        changeRegimeApp: "&",
        initialTabIndex: "=",
        changeCdu: "&",
        vendor: '<',
        portalRunned: '<'
    },
    controllerAs: "provGoodsManageCtrl",
    controller: ProvidersGoodsManagementController
});

function ProvidersGoodsManagementController(
    $typeDomainService,
    IvaBene,
    Resa,
    Garanzia,
    $financialApiService,
    $rootScope,
    $portalService,
    $scope,
    validationService,
    $simulationService
) {
    var self = this;

    self.$onInit = function () {
        if (self.vendor.reteVendita == 4 && $portalService.isAru()) {
            self.disabledFornitore = true;
        }
        self.supportModel = {
            disabledDays: [0],
            dsCdu: "",
            error: {
                importoCespite: false,
                accontiCompensazione: false
            },
            goodType: [],
            ivaType: [],
            resaType: [],
            warrantyType: [],
            goodSelected: {
                codiceCDU: "",
                descriptionCDU: "",
                defaultCDU: "",
                cdCategoriaBene: "",
                descriptionCatBene: "",
                cduCompatibileConAssicurazioni: "",
                flagAllestimento: "false",
                marcaAllestimento: "",
                modelloAllestimento: ""
            },
            initImpCespite: "",
            ivaSelected: {
                value: "",
                name: ""
            },
            isM12: false,
            cduIncompatibile: false,
            paymentIsVisible: false,
            guaranteeSelected: [],
            restitutionSelected: [],
            guaranteeDef: "",
            restitutionDef: "",
            placeholderFornitore: "",
            errorQuotaEsente: false,
            isCfFornitore: false,
            checkWithRegimeApplicabile: true,
            isAra: $portalService.isAra(),
            isAru: $portalService.isAru(),
            initialIndex: 0
        }

        self.supportModel.initialIndex = self.initialTabIndex || 0;

        if (getWizardMap(self.viewIndex) == "M15") {
            self.supportModel.placeholderFornitore = "";
            self.supportModel.goodSelected.codiceCDU = self.model.codiceCDU;
            self.supportModel.goodSelected.descriptionCDU = self.model.descriptionCDU;
            self.supportModel.goodSelected.defaultCDU = self.model.defaultCDU;
            self.supportModel.goodSelected.cdCategoriaBene = self.model.cdCategoriaBene;
            self.supportModel.goodSelected.descriptionCatBene = self.model.descriptionCatBene;
            self.supportModel.goodSelected.cduCompatibileConAssicurazioni = self.model.cduCompatibileConAssicurazioni;

            getCdu(self.preventivo.prodotto.id, self.preventivo.assicurazioni, self.model.idBene);
            getInfoAssetIva();
            getElencoGaranzieBene();

            getInfoAssetResaDef();
            /* 
            getInfoAssetWarrDef();
            */
        } else {
            // M12
            self.supportModel.isM12 = true
            self.supportModel.placeholderFornitore = "LBL_CF_PIVA_FORNITORE_PLACEHOLDER";
            self.model.description = self.model.description ? self.model.description : self.preventivo.prodotto.bene.descrizione;
            self.model.annoCostruzione = self.model.annoCostruzione ? self.model.annoCostruzione : self.preventivo.prodotto.bene.annoCostruzione;
            // self.model.fornitore = self.preventivo.fornitore;

        }

        if (!self.model.fornitore.accontiCompensazione) {
            self.model.fornitore.accontiCompensazione = 0;
        }

        self.model.dataDiConsegna = self.model.dataDiConsegna ? self.model.dataDiConsegna : self.preventivo.prodotto.bene.dataFirmaVerbale;
        self.supportModel.initImpCespite = self.model.importoCespite;
        self.supportModel.error.importoCespite = false;
        self.supportModel.error.accontiCompensazione = false;

        checkPayementVisible();
        checkValidation();

        if (!self.supportModel.isM12) {
            self.maxLengthInputBox = 50;
        }

        if (self.model && self.model.importoCespite && self.model.importoCespite == 0) {
            self.model.importoCespite = parseFloat(self.model.importoCespite);
        }
        self.model.beneProntaConsegna = self.model.beneProntaConsegna ? self.model.beneProntaConsegna : false;
        self.checkDataConsegna();
    };

    self.handleChange = function (property, value) {
        if (self.model.strumentale || self.model.flyNav ||
            self.model.ferroviario || self.model.immobiliare) {
            switch (property) {
                case "importoCespite":
                    var importoAltriCespiti = 0;
                    self.preventivo.prodotto.beneContratto.forEach(function (element) {
                        if (element.idBene == self.model.idBene) {
                            self.supportModel.initImpCespite = value;
                        } else {
                            importoAltriCespiti += parseFloat(element.importoCespite);
                        }
                    });

                    var newTotalAmount = (parseFloat(importoAltriCespiti) + parseFloat(self.supportModel.initImpCespite)).toFixed(2);

                    if (value > self.preventivo.importo || newTotalAmount > self.preventivo.importo) {
                        self.supportModel.error.importoCespite = true;
                    } else {
                        self.supportModel.error.importoCespite = false;
                        self.model[property] = parseFloat(value);
                        self.totalAmount({
                            newTotalAmount: newTotalAmount
                        });

                        self.newCespiteAmount({
                            cespiteAmount: value
                        })
                    }
                    if (self.supportModel.isM12) {
                        self.model.fornitore.modPagamento.listaTranches[0].importoPagamento = value;
                    }
                    break;
                case "stato":
                    self.model[property] = value;
                    self.changeStatus({
                        stato: value
                    });
                    checkPayementVisible();
                case "annoCostruzione":
                    self.model[property] = value;
                    break;
                case "accontiCompensazione":
                    if (parseFloat(value) > parseFloat(self.model.importoCespite)) {
                        self.supportModel.error.accontiCompensazione = true;
                    } else {
                        self.supportModel.error.accontiCompensazione = false;
                        self.model.fornitore[property] = value;
                    }
                    break;
                case "ivaBene":
                    self.model.ivaBene = IvaBene.build({
                        id: value.value,
                        description: value.name
                    });
                    self.supportModel.ivaSelected.id = value.value;
                    self.supportModel.ivaSelected.name = value.name;
                    break;
                case "resa":
                    self.model.resa = Resa.build({
                        id: value.value,
                        description: value.name
                    });
                    self.supportModel.restitutionSelected.value = value.value;
                    self.supportModel.restitutionSelected.description = value.name;
                    break;
                case "garanzia":
                    self.model.garanzia = Garanzia.build(value);
                    break;
                case "dataDiConsegna":
                    self.model[property] = value;
                    self.checkDataConsegna();
                    break;
                case "email":
                case "telefono":
                case "description":
                    self.model.fornitore.riferimento[property] = value;
                    break;
                case "accontiDaUsare":
                    self.model.fornitore[property] = value;
                    if (!self.model.fornitore.accontiDaUsare) {
                        self.model.fornitore.accontiCompensazione = 0;
                        jQuery('#currency-compensationAmount1').removeClass('has-error');
                    }
                    break;
                case "cfPiva":
                case "estero":
                case "rappresentanteItalia":
                    self.model.fornitore[property] = value;

                    if (!self.model.fornitore.estero) {
                        self.model.fornitore.rappresentanteItalia = ""
                    }

                    if (property == "cfPiva" && self.model.immobiliare.regimeApplicabile === "imposta di registro") {
                        checkFornitoreType(value);
                    }
                    if (property == "estero" && self.model.fornitore.estero) {
                        var testPiva = validationService.cfPivaPlus.test(self.model.fornitore.cfPiva);
                        $scope.providersGoodsForm.pivaEstera.$setValidity('pivaEstera', testPiva);
                    } else {
                        var testPiva = validationService.cfPiva.test(self.model.fornitore.cfPiva);
                        $scope.providersGoodsForm.piva.$setValidity('piva', testPiva);
                    }
                    break;
                case "descrizioneBene":
                    self.model.description = value && value.replace(/[\u0000-\u001f]/gi, '')
                        .replace(/[\u0080-\u009f]/gi, '')
                        .replace(/[\u0100-\uffff]/gi, '');
                    break;
                case "fornitoreDescr":
                    self.model.fornitore.descrizione = value;
                    break;
                case "regimeApplicabile":
                    if (value === "imposta di registro") {
                        checkFornitoreType(self.model.fornitore.cfPiva);
                    } else {
                        self.model.quotaEsente = 0;
                        self.supportModel.checkWithRegimeApplicabile = true;
                    }
                    self.model.immobiliare[property] = value;

                    self.changeRegimeApp({
                        regimeApplicabile: true
                    });
                    break;
                case "quotaEsente":
                    if (parseFloat(self.model.quotaEsente) > self.model.importoCespite) {
                        self.supportModel.errorQuotaEsente = true;
                    } else {
                        self.supportModel.errorQuotaEsente = false;
                        self.model[property] = value;
                    }
                    break;
                case "prontaConsegna":
                    self.model.beneProntaConsegna = value;
                    self.checkDataConsegna();
                    break;
                default:
                    self.model[property] = value;
                    break;

            }
        }
        checkValidation();
    }

    self.handleCDUChange = function (property, value) {
        self.supportModel.cduIncompatibile = true;
        if (property) {
            self.supportModel.dsCdu = value.descriptionCDU;
            self.model.codiceCDU = value.codiceCDU;
            self.model.descriptionCDU = value.descriptionCDU;
            self.model.defaultCDU = value.defaultCDU;
            self.model.cdCategoriaBene = value.cdCategoriaBene;
            self.model.descriptionCatBene = value.descriptionCatBene;
            self.model.cduCompatibileConAssicurazioni = value.cduCompatibileConAssicurazioni;
        }

        self.changeCdu({
            cduChanged: true
        });

        self.supportModel.cduIncompatibile = !self.supportModel.goodSelected.cduCompatibileConAssicurazioni ? self.supportModel.goodSelected.cduCompatibileConAssicurazioni : true;

        if (value.flagAllestimento === "true" &&
            (self.preventivo.prodotto.id === "AVC" || self.preventivo.prodotto.id === "AVI")) {
            self.flagAllestimento({
                allestimento: true
            });

            var ojbSelected = [];
            ojbSelected.push({
                marca: value.marcaAllestimento
            });
            ojbSelected.push({
                modello: value.modelloAllestimento
            });

            self.allestimentoObj({
                allestimentoObj: ojbSelected
            });
        } else {
            self.flagAllestimento({
                allestimento: false
            });
        }
    }

    var checkValidation = function () {
        //popolo il modello nel caso in cui venga scelto il tipo bene di default
        self.model.codiceCDU = self.supportModel.goodSelected.codiceCDU;
        self.model.descriptionCDU = self.supportModel.goodSelected.descriptionCDU;
        self.model.defaultCDU = self.supportModel.goodSelected.defaultCDU;
        self.model.cdCategoriaBene = self.supportModel.goodSelected.cdCategoriaBene;
        self.model.descriptionCatBene = self.supportModel.goodSelected.descriptionCatBene;
        self.model.cduCompatibileConAssicurazioni = self.supportModel.goodSelected.cduCompatibileConAssicurazioni;

        var test = false;
        var testBoat = false;
        var testAmountFor = false;

        //se non sono nell'on init devo verificare un cespite alla volta
        if (self.model.idBene) {
            if (getWizardMap(self.viewIndex) == "M15") {
                test =
                    self.model.codiceCDU && self.model.descriptionCDU &&
                    self.model.resa.id && self.model.ivaBene.id &&
                    self.model.garanzia.id &&
                    self.model.annoCostruzione &&
                    self.model.importoCespite &&
                    (self.model.dataDiConsegna || self.model.beneProntaConsegna) &&
                    self.model.description &&
                    !self.supportModel.error.importoCespite &&
                    !self.supportModel.error.accontiCompensazione &&
                    self.model.cduCompatibileConAssicurazioni;

                if (self.model.fornitore.estero) {
                    testBoat = self.model.fornitore.rappresentanteItalia
                } else {
                    testBoat = true;
                }

                if (!self.model.fornitore.accontiDaUsare) {
                    testAmountFor = (self.model.fornitore.accontiCompensazione != null && self.model.fornitore.accontiCompensazione != "") ||
                        self.model.fornitore.accontiCompensazione == 0;
                } else {
                    testAmountFor = self.model.fornitore.accontiCompensazione;
                }

                var testRegimeApplicabile = false;
                if (self.preventivo.prodotto.id !== "IMM") {
                    testRegimeApplicabile = true;
                } else {
                    if (self.model.immobiliare.regimeApplicabile === "imposta di registro" &&
                        parseInt(self.model.quotaEsente) > 0) {
                        testRegimeApplicabile = true;
                    } else if (self.model.immobiliare.regimeApplicabile === "imposta valore aggiunto") {
                        testRegimeApplicabile = true;
                    }
                }
            } else {
                // M12
                test = self.model.importoCespite &&

                    (self.model.dataDiConsegna || self.model.beneProntaConsegna) &&
                    self.model.annoCostruzione &&
                    self.model.description &&
                    self.model.fornitore.cfPiva &&
                    self.model.fornitore.riferimento.email &&
                    self.model.fornitore.riferimento.telefono &&
                    self.model.fornitore.riferimento.description &&
                    !self.supportModel.error.importoCespite &&
                    !self.supportModel.error.accontiCompensazione &&
                    !self.supportModel.errorQuotaEsente;

                if (self.model.fornitore.estero) {
                    testBoat = self.model.fornitore.rappresentanteItalia
                } else {
                    testBoat = true;
                }

                if (!self.model.fornitore.accontiDaUsare) {
                    testAmountFor = (self.model.fornitore.accontiCompensazione != null && self.model.fornitore.accontiCompensazione != "") ||
                        self.model.fornitore.accontiCompensazione == 0;
                } else {
                    testAmountFor = self.model.fornitore.accontiCompensazione;
                }

                var testRegimeApplicabile = false;
                if (self.preventivo.prodotto.id !== "IMM") {
                    testRegimeApplicabile = true;
                } else {
                    if (self.model.immobiliare.regimeApplicabile === "imposta di registro" &&
                        self.supportModel.isCfFornitore &&
                        parseInt(self.model.quotaEsente) > 0) {
                        testRegimeApplicabile = true;
                    } else if (self.model.immobiliare.regimeApplicabile === "imposta valore aggiunto") {
                        testRegimeApplicabile = true;
                    }
                }
            }
        } else {
            //se sono nell'on init verifico tutti i cespiti che ho inserito
            self.preventivo.prodotto.beneContratto.forEach(function (element) {
                if (getWizardMap(self.viewIndex) == "M15") {
                    test =
                        element.codiceCDU && element.descriptionCDU &&
                        element.resa.id && element.ivaBene.id &&
                        element.garanzia.id &&
                        element.importoCespite &&
                        element.annoCostruzione &&
                        (element.dataDiConsegna || element.beneProntaConsegna) &&
                        element.description &&
                        !self.supportModel.error.importoCespite &&
                        !self.supportModel.error.accontiCompensazione &&
                        self.model.cduCompatibileConAssicurazioni;

                    if (element.fornitore.estero) {
                        testBoat = element.fornitore.rappresentanteItalia
                    } else {
                        testBoat = true;
                    }

                    if (!element.fornitore.accontiDaUsare) {
                        testAmountFor = (element.fornitore.accontiCompensazione != null && element.fornitore.accontiCompensazione != "") ||
                            element.fornitore.accontiCompensazione == 0;
                    } else {
                        testAmountFor = element.fornitore.accontiCompensazione;
                    }

                    var testRegimeApplicabile = false;
                    if (self.preventivo.prodotto.id !== "IMM") {
                        testRegimeApplicabile = true;
                    } else {
                        if (self.model.immobiliare.regimeApplicabile === "imposta di registro" &&
                            parseInt(self.model.quotaEsente) > 0) {
                            testRegimeApplicabile = true;
                        } else if (self.model.immobiliare.regimeApplicabile === "imposta valore aggiunto") {
                            testRegimeApplicabile = true;
                        }
                    }

                } else {
                    // M12
                    test = element.importoCespite &&
                        (element.dataDiConsegna || element.beneProntaConsegna) &&
                        element.annoCostruzione &&
                        element.description &&
                        element.fornitore.riferimento.email &&
                        element.fornitore.riferimento.telefono &&
                        element.fornitore.riferimento.description &&
                        !self.supportModel.error.importoCespite &&
                        !self.supportModel.error.accontiCompensazione &&
                        !self.supportModel.errorQuotaEsente;

                    if (element.fornitore.estero) {
                        testBoat = element.fornitore.rappresentanteItalia
                    } else {
                        testBoat = true;
                    }

                    if (!element.fornitore.accontiDaUsare) {
                        testAmountFor = (element.fornitore.accontiCompensazione != null && element.fornitore.accontiCompensazione != "") ||
                            element.fornitore.accontiCompensazione == 0;
                    } else {
                        testAmountFor = element.fornitore.accontiCompensazione;
                    }
                    var testRegimeApplicabile = false;
                    if (self.preventivo.prodotto.id !== "IMM") {
                        testRegimeApplicabile = true;
                    } else {
                        if (self.model.immobiliare.regimeApplicabile === 'imposta di registro' &&
                            self.supportModel.isCfFornitore &&
                            parseInt(self.model.quotaEsente) > 0) {
                            testRegimeApplicabile = true;
                        } else if (self.model.immobiliare.regimeApplicabile === "imposta valore aggiunto") {
                            testRegimeApplicabile = true;
                        }
                    }
                }
            });
        }

        if (test && testBoat && testAmountFor && testRegimeApplicabile) {
            self.provGoodIsOk();
        } else {
            self.provGoodIsNotOk();
        }
    }

    var getCdu = function (cdProdotto, assicurazioni, idBene) {
        var assicurazioniList = []
        assicurazioni.forEach(function (element) {
            assicurazioniList.push(element.id);
        });
        self.cduRestIsPending = true;
        $financialApiService
            .retrieveCdu(cdProdotto, assicurazioniList, idBene, self.vendor.riUserG.ndg, self.preventivo.convenzionePrm.cdConvenzione)
            .then(function (response) {
                self.cduRestIsPending = false;
                self.supportModel.goodType = response;
                self.supportModel.goodType.forEach(function (element) {
                    //verifico se la cdu è stata già selezionata in precedenza
                    if (self.supportModel.goodSelected.codiceCDU) {
                        if (self.supportModel.goodSelected.codiceCDU === element.codiceCDU) {
                            self.supportModel.goodSelected.codiceCDU = element.codiceCDU;
                            self.supportModel.goodSelected.descriptionCDU = element.descriptionCDU;
                            self.supportModel.goodSelected.defaultCDU = element.defaultCDU;
                            self.supportModel.goodSelected.cdCategoriaBene = element.cdCategoriaBene;
                            self.supportModel.goodSelected.descriptionCatBene = element.descriptionCatBene;
                            self.supportModel.goodSelected.cduCompatibileConAssicurazioni = element.cduCompatibileConAssicurazioni;
                            self.supportModel.goodSelected.flagAllestimento = element.flagAllestimento;
                            self.supportModel.goodSelected.marcaAllestimento = element.marcaAllestimento;
                            self.supportModel.goodSelected.modelloAllestimento = element.modelloAllestimento;
                        }
                    } else {
                        //altrimenti assegno quella di default
                        if (element.defaultCDU === "S") {
                            self.supportModel.goodSelected.codiceCDU = element.codiceCDU;
                            self.supportModel.goodSelected.descriptionCDU = element.descriptionCDU;
                            self.supportModel.goodSelected.defaultCDU = element.defaultCDU;
                            self.supportModel.goodSelected.cdCategoriaBene = element.cdCategoriaBene;
                            self.supportModel.goodSelected.descriptionCatBene = element.descriptionCatBene;
                            self.supportModel.goodSelected.cduCompatibileConAssicurazioni = element.cduCompatibileConAssicurazioni;
                            self.supportModel.goodSelected.flagAllestimento = element.flagAllestimento;
                            self.supportModel.goodSelected.marcaAllestimento = element.marcaAllestimento;
                            self.supportModel.goodSelected.modelloAllestimento = element.modelloAllestimento;
                        }
                    }
                })

                if (self.supportModel.goodSelected.flagAllestimento === "true" &&
                    (self.preventivo.prodotto.id === "AVC" || self.preventivo.prodotto.id === "AVI")) {
                    self.flagAllestimento({
                        allestimento: true
                    });

                    var ojbSelected = [];
                    ojbSelected.push({
                        marca: self.supportModel.goodSelected.modelloAllestimento
                    });
                    ojbSelected.push({
                        modello: self.supportModel.goodSelected.modelloAllestimento
                    });

                    self.allestimentoObj({
                        allestimentoObj: ojbSelected
                    });
                } else {
                    self.flagAllestimento({
                        allestimento: false
                    });
                }

                self.supportModel.cduIncompatibile = !self.supportModel.goodSelected.cduCompatibileConAssicurazioni ?
                    self.supportModel.goodSelected.cduCompatibileConAssicurazioni : true;
            }).catch(function (error) {
                console.error(error);
            });
    }

    var getInfoAssetIva = function () {
        $financialApiService
            .getIVAWithFilter(true, false, self.preventivo.prodotto.id)
            .then(function (response) {
                self.supportModel.ivaType = response.domainList;
                var elementFound = self.supportModel.ivaType.some(function (element) {
                    return self.model.ivaBene.id === element.value
                })
                if (elementFound) {
                    self.supportModel.ivaSelected.value = self.model.ivaBene.id;
                    self.supportModel.ivaSelected.name = self.model.ivaBene.description;
                } else {
                    self.supportModel.ivaSelected = self.supportModel.ivaType[0];

                    self.model.ivaBene = IvaBene.build({
                        id: self.supportModel.ivaSelected.value,
                        description: self.supportModel.ivaSelected.name
                    });
                }
            })
            .catch(function (error) {
                console.error(error);
            });
    };

    var getInfoAssetWarrDef = function () {
        $typeDomainService.getDomainSet("ADDITIONAL_INFO_ASSET", "GUARANTEE_REAL_DEFAULT").then(function (response) {
            response.domainList.forEach(function (element) {
                if (element.value === self.preventivo.prodotto.id) {
                    self.supportModel.guaranteeDef = element.name;
                }
            });
            getInfoAssetWarr();
        });
    };

    var getElencoGaranzieBene = function () {
        $financialApiService.getElencoGaranzieBene(self.vendor.riUserG.ndg, self.preventivo.prodotto.id)
            .then(function (response) {
                self.supportModel.warrantyType = response;
                if (self.model.garanzia.id) {
                    self.supportModel.guaranteeSelected = self.model.garanzia
                } else {
                    self.supportModel.guaranteeSelected = response
                        .find(function (element) {
                            return element.select == true;
                        })

                    self.model.garanzia = Garanzia.build(self.supportModel.guaranteeSelected);
                }

            })
    }

    var getInfoAssetWarr = function () {
        $typeDomainService.getDomainSet("ADDITIONAL_INFO_ASSET", "GUARANTEE_REAL").then(function (response) {
            self.supportModel.warrantyType = response.domainList;
            if (self.supportModel.guaranteeDef) {
                var elementFound = self.supportModel.resaType.some(function (element) {
                    return self.model.garanzia.id === element.value
                })
                if (elementFound) {
                    self.supportModel.guaranteeSelected.value = self.model.garanzia.id;
                    self.supportModel.guaranteeSelected.description = self.model.garanzia.description;
                } else {
                    self.supportModel.warrantyType.forEach(function (element) {
                        if (self.supportModel.guaranteeDef === element.value) {
                            self.supportModel.guaranteeSelected.value = element.value;
                            self.supportModel.guaranteeSelected.description = element.description;
                            self.model.garanzia = Garanzia.build({
                                id: element.value,
                                description: element.description
                            });
                        }
                    });
                }
            } else if (self.model.garanzia.id) {
                self.supportModel.guaranteeSelected.value = self.model.garanzia.id;
                self.supportModel.guaranteeSelected.description = self.model.garanzia.description;
            }
        });
    };

    var getInfoAssetResaDef = function () {
        $typeDomainService.getDomainSet("ADDITIONAL_INFO_ASSET", "RESTITUTION_DEFAULT").then(function (response) {
            response.domainList.forEach(function (element) {
                if (element.value === self.preventivo.prodotto.id) {
                    self.supportModel.restitutionDef = element.name;
                }
            });
            getInfoAssetResa();
        });
    };

    var getInfoAssetResa = function () {
        $simulationService.getResa(self.vendor.riUserG.ndg)
            .then(function (response) {
                self.supportModel.resaType = response.domainList;
                if (self.supportModel.restitutionDef) {
                    var elementFound = self.supportModel.resaType.some(function (element) {
                        return self.model.resa.id === element.value
                    })
                    if (elementFound) {
                        self.supportModel.restitutionSelected.value = self.model.resa.id;
                        self.supportModel.restitutionSelected.description = self.model.resa.description;
                    } else {
                        self.supportModel.resaType.forEach(function (element) {
                            if (self.supportModel.restitutionDef === element.value) {
                                self.supportModel.restitutionSelected.value = element.value;
                                self.supportModel.restitutionSelected.description = element.description;

                                self.model.resa = Resa.build({
                                    id: element.value,
                                    description: element.description
                                });
                            }
                        });
                    }
                } else if (self.model.resa.id) {
                    self.supportModel.restitutionSelected.value = self.model.resa.id;
                    self.supportModel.restitutionSelected.description = self.model.resa.description;
                }
            }).catch(function (error) {
                return $q.reject(error);
            });
    };

    var getWizardMap = function (viewIndex) {
        return $rootScope.wizardMap
            .find(function (element) {
                return element.index == viewIndex
            }).viewName
    }

    var checkPayementVisible = function () {
        if ($portalService.isAra()) {
            if (self.preventivo.prodotto.isTargato &&
                self.model.stato === "LBL_GOOD_STATE_NEW") {
                self.supportModel.paymentIsVisible = true;
            } else {
                self.supportModel.paymentIsVisible = false;
            }
        } else {
            if (self.preventivo.prodotto.isTargato && self.model.stato === "LBL_GOOD_STATE_NEW") {
                self.supportModel.paymentIsVisible = true;

                if (self.supportModel.paymentIsVisible && self.model.fornitore.pagamentoPreImmatricolazione == null) {
                    getPreImmaValue();
                }
            } else {
                self.supportModel.paymentIsVisible = false;
            }
        }
    }

    var checkFornitoreType = function (cfPiva) {
        if (cfPiva && cfPiva.length == 16) {
            self.supportModel.isCfFornitore = true;
            self.supportModel.checkWithRegimeApplicabile = true;
        } else if (cfPiva && cfPiva.length == 11) {
            self.supportModel.isCfFornitore = false;
            self.supportModel.checkWithRegimeApplicabile = false;
        }
    }

    var getPreImmaValue = function () {
        $typeDomainService.getDomainSet("VENDOR_PAYMENTS", "TARGATO_PREIMMATR").then(function (response) {

            self.model.fornitore.pagamentoPreImmatricolazione = response.domainList.some(function (element) {
                return element.value == self.preventivo.fornitore.modPagamento.id
            })

            getInfoAssetResa();
        });
    }

    self.checkDataConsegna = function () {
        if (self.model.beneProntaConsegna) {
            self.dataConsegnaOk = true;
            self.model.dataDiConsegna = null;
        } else {
            self.dataConsegnaOk = (!self.model.beneProntaConsegna && self.model.dataDiConsegna)
        }
    }
}